import * as React from 'react';

import classNames from 'classnames';

import { cutStringTo, isIeBrowser } from '@utils';

import { IDescriptionProps } from './types';

import * as s from './Description.scss';

export const Description: React.FC<IDescriptionProps> = ( props: IDescriptionProps ) => {
	const {
		className,
		description,
		length,
	} = props;
	let shortDescription = '';

	if (description) {
		if (length) {
			shortDescription = cutStringTo(description, length);
		} else {
			shortDescription = isIeBrowser()
				? cutStringTo(description, 85)
				: description;
		}
	}

	return description != null
		? (
			<div className={classNames(s.block, className)}>
				{ shortDescription }
			</div>
		)
		: null;
};

Description.defaultProps = {
	length: 100,
};
